import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ButtonVariant } from "../../../../button/ButtonVariant";
import { ReflectiveDialogs } from "../../../../../base/ReflectiveDialogs";
import { ReflectiveSnackbars } from "../../../../../base/ReflectiveSnackbars";
import { TableRow } from "../../../TableRow";

export class DeleteButton extends AbstractTableHeadingButton {
    override create() {
        super.create();
        this.button.setProps({
            id: `${this.table.id}-tools-buttonDelete`,
            variant: ButtonVariant.round,
            enabled: false,
            imageName: ImageName.delete,
            onClick: () => this.handleDelete(),
            tooltip: "Delete the selected rows"
        });
    }

    override rowSelectionChanged() {
        this.syncEnabled();
    }

    private syncEnabled() {
        this.button.enabled = this.table.selectedRowCount > 0 &&
            this.table.selectedRows.every((row: TableRow) => row.allowDelete === true);
    }

    private async handleDelete() {
        const sel = this.table.selectedRows;
        if (sel.length === 0) {
            ReflectiveDialogs.showMessage("No records are selected to delete.");
            return;
        }
        const prompt = "Are you sure you want to delete the selected " + (sel.length === 1 ? "record" : "records") + "?";
        if (await ReflectiveDialogs.showYesNo(prompt, "Confirm Delete")) {
            for (let i = sel.length - 1; i >= 0; i--) {
                await sel[i].data.delete();
                this.table.removeRow(sel[i].index);
            }
            ReflectiveSnackbars.showSnackbar("Selected " + (sel.length === 1 ? "record has" : "records have") + " been deleted.");
        }
    }
}
